module.exports = __webpack_public_path__ + "static/img/children12.e92fbd8a.jpg";